import {verifyCode, verifySms, submitData, resendCode, cancelRequest, submitNameEmail} from "./services";

export const createFlowState = (state) => {
    return {
        step() {
            return state.currentStep;
        },
        currentStepIs(step) {
            return state.currentStep === step;
        },
        lastStep() {
            state.currentStep = 3;
        },
        setPhoneNumberValidationRequestId(value) {
            state.validation = value;
        },
        getPhoneNumberValidationRequestId() {
            return state.validation
        },
        getTimeRemaining() {
            return state.timeRemaining;
        },
        getCountDownStatus() {
            return state.countDown;
        },
        setHubspotStatus() {
            state.submitHubspot = true;
        },
        getHubspotStatus() {
            return state.submitHubspot;
        },
        isComplete() {
            return state.currentStep > 2;
        },
        next() {
            state.currentStep++;
        },
        nextButtonText() {
            return {
                0: 'Go next >',
                1: 'Send request >',
                2: 'Submit'
            }[state.currentStep] || 'Send Request >';
        },
        prev() {
            state.currentStep--;
        },
        prevButtonText() {
            return 'Update the phone number';
        },
        close() {
            window.vf.contactFormFlow.close();
        },
        franchiseId() {
            return state.form.franchiseId;
        },
        franchiseName() {
            return state.form.franchiseName;
        },
        phoneNumber() {
            return state.form.phoneNumber;
        },
        fullPhoneNumber() {
            return state.form.fullPhoneNumber;
        },
        setPrevPhoneNumber(value) {
            state.prevPhoneNumber = value;
        },
        getPrevPhoneNumber() {
            return state.prevPhoneNumber;
        },
        userData() {
            return state.form;
        },
        startCountdown() {
            state.countDown = true;
        },
        stopCountdown() {
            state.countDown = false;
        },
        getBackToStep2() {
            return state.backToStep2;
        },
        setBackToStep2() {
            state.backToStep2 = true;
        },
        getVerifyAttempts() {
            return state.verifyAttempts;
        },
        setTimer() {

        },
        setInterval() {

        },
        setVerifyAttempts(value) {
            state.verifyAttempts = value;
        },
        updateVerifyAttempts() {
            state.verifyAttempts++;
        },
        resendTimerIsActive() {
            return true;
        },
        value: state.form,
        setFormValue(key, value) {
            state.form[key] = value;
        },
        getFranchiseName() {
            return state.form.franchiseName;
        },
        getPageName() {
            return state.form.pageName;
        },
        getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        checkLimits() {
            // Get cookies
            const limit = getCookie('cffLimit');
            const pathname = $(location).attr("pathname");

            // Get data if franchise or page
            let requested = pathname.indexOf('/franchises/') !== -1 ? getCookie('cffRequested') : getCookie('cffPageRequested');

            if (!Array.isArray(requested) && requested !== '') {
                requested = requested.replace(/,$/, '').split(',');
            }

            // If cookie exists
            if (Array.isArray(requested)) {

                // For each element add his respective class
                $("[data-franchise-id]").each(function () {
                    // Check if franchise was requested
                    if (requested.findIndex(item => item === $(this).data('franchise-id').toString()) !== -1) {

                        // Mark as requested
                        $(this).addClass('cff-success');
                        $(this).html('Request submitted');
                    }
                    // If franchise was not requested
                    else {
                        // Check limits
                        if (limit === '0') {
                            // Mark as disabled
                            $(this).addClass('disabled');
                            $('.request-limits').show();
                        }
                    }
                });
            }
        },
        services: {
            verifyCode,
            verifySms,
            submitData,
            resendCode,
            cancelRequest,
            submitNameEmail
        }
    }
}